<script>
  import {
    Tabs,
    TabsItem,
    Breadcrumb,
    BreadcrumbItem,
    Loader,
    Badge,
  } from "@gl/design-system";
  import { Route, Router, Link, navigate } from "svelte-routing";
  import { onMount } from "svelte";
  import { _, user, url } from "../stores/index";
  import MeData from "./MeData.svelte";
  import MePreferences from "./MePreferences.svelte";

  let selectedTab = "data";

  const setSelectedTabFromPathname = () => {
    if ($url.pathname.includes("preferences")) {
      selectedTab = "preferences";
    } else {
      selectedTab = "data";
    }
  };

  $: if ($url) setSelectedTabFromPathname();

  onMount(() => {
    setSelectedTabFromPathname();
  });
</script>

<div class="main me p-6" style="height:100%">
  <h1 class="gl-title">
    {$_("common.profile")}: {$user.data.firstName}
    {$user.data.lastName}
  </h1>
  <Tabs class="mt-5">
    <TabsItem selected={selectedTab === "data"}>
      <Link to={`me/data`} on:click={() => (selectedTab = "data")}
        >{$_("users.data")}</Link
      >
    </TabsItem>
    <TabsItem selected={selectedTab === "preferences"}>
      <Link
        to={`/me/preferences`}
        on:click={() => (selectedTab = "preferences")}
        >{$_("common.preferences")}</Link
      >
    </TabsItem>
  </Tabs>

  <Router>
    <Route path="/data">
      <MeData />
    </Route>
    <Route path="/preferences">
      <MePreferences />
    </Route>
  </Router>
</div>

<style>
  .me {
    margin-left: 262px;
    width: 75%;
    margin: 0 auto;
  }
</style>
